// extracted by mini-css-extract-plugin
export default {"modal":"ConfirmationModal_modal__1WhfJ","description":"ConfirmationModal_description__Wszyg"};